import { BehaviorSubject } from 'rxjs';
import get from 'lodash.get';
export const getCalculationStepDetailsStore = () => {
    const getInitialState = () => ({
        items: [],
        documents: [],
        warnings: [],
        isLoading: false,
        displayData: {}
    });
    const stepDetailsSubject = new BehaviorSubject(getInitialState());
    const getStepDetailsItems = () => stepDetailsSubject.getValue().items;
    const getStepDetailsDocuments = () => stepDetailsSubject.getValue().documents;
    const subscribe = (callback) => stepDetailsSubject.subscribe(callback);
    const startFetching = () => stepDetailsSubject.next({
        ...stepDetailsSubject.getValue(),
        isLoading: true
    });
    const setStepDetails = (items, documents, warnings) => {
        stepDetailsSubject.next({
            items: items,
            documents: documents,
            warnings: warnings,
            isLoading: false,
            displayData: {}
        });
    };
    const setIsLoading = (isLoading) => stepDetailsSubject.next({
        ...stepDetailsSubject.getValue(),
        isLoading
    });
    const setDisplayData = (data) => stepDetailsSubject.next({
        ...stepDetailsSubject.getValue(),
        displayData: data
    });
    const getDisplayData = () => stepDetailsSubject.getValue().displayData;
    const getItemDisplayValue = (identifier) => get(stepDetailsSubject.getValue().displayData, identifier);
    return {
        getStepDetailsItems,
        getStepDetailsDocuments,
        getInitialState,
        startFetching,
        setStepDetails,
        setIsLoading,
        setDisplayData,
        getDisplayData,
        getItemDisplayValue,
        subscribe
    };
};
